import { icons } from 'src/assets/iconDef/icon.def';

export const CssdMenuDef = [
    {
        name: 'menu.received_raised_indent',
        icon: 'fa fa-tag',
        resource: 'received_indent_raised',
        url: 'received_indent_raised',
        auto_crud: true
    },
    {
        name: 'menu.indent_raised',
        icon: 'fa fa-tag',
        resource: 'indent_raised',
        url: 'indent_raised',
        auto_crud: true
    },
    {
        name: 'menu.received_indent_issued',
        icon: 'fa fa-tag',
        resource: 'received_indent_issued',
        url: 'received_indent_issued',
        auto_crud: true
    },
    {
        name: 'menu.issue_indent',
        icon: 'fa fa-tag',
        resource: 'indent_issued',
        url: 'indent_issued',
        auto_crud: true
    },
    {
        name: 'menu.return_indent',
        icon: 'fa fa-tag',
        resource: 'return_indent',
        url: 'return_indent',
        auto_crud: true
    },
    {
        name: 'menu.received_return_indent',
        icon: 'fa fa-tag',
        resource: 'received_return_indent',
        url: 'received_return_indent',
        auto_crud: true
    },
    {
        name: 'menu.discard_item',
        icon: 'fa fa-tag',
        resource: 'discard_indent',
        url: 'discard_indent',
        auto_crud: true
    },
    {
        name: 'menu.sterilization_request',
        icon: 'fa fa-tag',
        resource: 'sterilization_request',
        url: 'sterilization_request',
        auto_crud: true
    },
    {
        name: 'menu.view_stock',
        resource: 'store_stock',
        icon: 'fa fa-user',
        url: 'store_stock',
        auto_crud: true
    },
    {
        name: 'menu.indent',
        resource: 'commonIndentLayout',
        icon: 'fa fa-user',
        url: 'commonIndentLayout',
        auto_crud: true,
        breadcrumb: 'Indent'
    }
]
